/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import {
  Link,
  Modal,
  ModalBody,
  ModalFooter,
  ModalFooterButton,
  ModalHeader,
} from '@smartsheet/lodestar-core';
import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

const modalStyle = css`
  position: relative;
  top: 50%;
  transform: translateY(-45%);
`;

export const FailureModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t: translate } = useTranslation();

  return (
    <Modal
      aria-labelledby="signin-failure"
      isOpen={isOpen}
      onCloseRequested={() => setIsOpen(false)}
      width="small"
      css={modalStyle}
    >
      <ModalHeader
        title={translate('signin:unableToSignin')}
        titleProps={{ id: 'signin-failure' }}
      />
      <ModalBody>
        <p>
          {translate('signin:unableToSigninDescription')}{' '}
          <Link href="">{translate('common:help').toLowerCase()}</Link>.
        </p>
      </ModalBody>
      <ModalFooter>
        <ModalFooterButton onClick={() => setIsOpen(false)}>
          {translate('common:ok')}
        </ModalFooterButton>
      </ModalFooter>
    </Modal>
  );
};
